import { REHYDRATE } from "redux-persist/lib/constants";
import { take, takeEvery, takeLatest } from "redux-saga/effects";
import { constant } from "../constant";
import {
  confirmBookingSagaAction,
  newSessionPreCleanUpSagaAction,
} from "./ConfirmBookingSagaAction";
import { getInstructorAvailablitySagaAction } from "./InstructorAvailablitySagaAction";
import { getPreAppointmentDataSagaAction, getPreAppointmentDataDurationSagaAction } from "./PreAppointmentDataSageAction";
import { getQuestionnaireSagaAction } from "./QuestionnaireSagaAction";
import { getTherapySagaAction } from "./TherapySagaAction";
// import { getConsentFormStatus } from "./IntakeFormSagaAction";
import { userLogOutAction } from "./UserAuthSagaAction";
import { getMbcDataSagaAction, getMyJourneyGraphSagaAction } from "./MbcSagaAction";

// watchers
function* SagaActions() {
  yield take(REHYDRATE);
  yield takeEvery(constant.LOGOUT, userLogOutAction);
  yield takeLatest(
    constant.NEW_SESSION_PRE_CLEANUP,
    newSessionPreCleanUpSagaAction
  );

  // pre appointment data
  yield takeLatest(
    constant.GET_PRE_APPOINTMENT_DATA,
    getPreAppointmentDataSagaAction
  );
  // pre appointment data duration
  yield takeLatest(
    constant.GET_PRE_APPOINTMENT_DATA_DURATION,
    getPreAppointmentDataDurationSagaAction
  );
  // instructor availibility
  yield takeLatest(
    constant.GET_INSTRUCTOR_AVAILABLITY,
    getInstructorAvailablitySagaAction
  );

  yield takeLatest(constant.CONFIRM_BOOKING, confirmBookingSagaAction);

  // therapy index
  yield takeLatest(constant.GET_THERAPY_INDEX, getTherapySagaAction);

  // questionnaire
  yield takeLatest(constant.GET_QUESTIONNAIRE, getQuestionnaireSagaAction);

  //intakeform
  // yield takeLatest(constant.GET_CONSENT_FORM_STATUS, getConsentFormStatus);

  //mbc
  yield takeLatest(constant.GET_MBC_DATA, getMbcDataSagaAction);
  yield takeLatest(constant.GET_MY_JOURNEY_GRAPH, getMyJourneyGraphSagaAction);
}
export default SagaActions;
